/**
 * Model for Smart Tag Form Image
 */
export class SmartTagFormModel {
	public selectedSmartTagItem: any;
	public smartTagData?: any;
	public smartTagTemplateChangeFrom?: any;
	public smartTagTemplateChangeFromFields?: any;
	public asGroupKey?: boolean;
	public imageless?: boolean;

	constructor() {
		this.asGroupKey = false;
		this.selectedSmartTagItem = null;
		this.smartTagData = null;
		this.smartTagTemplateChangeFrom = null;
		this.smartTagTemplateChangeFromFields = null;
		this.imageless = false;
	}
}
